// src/pages/Nebortovye.js
import React, { useState } from 'react';
import CountUp from 'react-countup';
import './Nebortovye.css';

const Nebortovye = () => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [responseMsg, setResponseMsg] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, tab: 'nebortovye' }),
      });
      const data = await response.json();
      if (response.ok) {
        setResponseMsg(data.message || 'Заявка успешно отправлена!');
        setFormData({ name: '', phone: '' });
      } else {
        setResponseMsg(data.message || 'Ошибка при отправке');
      }
    } catch (err) {
      console.error(err);
      setResponseMsg('Ошибка подключения к серверу');
    }
  };

  return (
    <div className="nebortovye-page">
      {/* Шапка */}
      <header className="nebortovye-header">
        <div className="header-overlay">
          <h1>Небортовые перевозки</h1>
          <p>Эффективная транспортировка грузов без боковых конструкций</p>
        </div>
      </header>

      {/* Информационная секция */}
      <section className="nebortovye-info">
        <div className="container">
          <h2>Что такое небортовые перевозки?</h2>
          <p>
            Небортовые перевозки предназначены для транспортировки грузов, которые не требуют закрытого кузова. 
            Такой тип перевозок обеспечивает большую гибкость и позволяет перевозить крупногабаритные и негабаритные грузы с максимальной эффективностью.
          </p>
          <h3>Основные особенности:</h3>
          <ul>
            <li>Быстрая загрузка и разгрузка</li>
            <li>Оптимизация использования пространства</li>
            <li>Универсальность в перевозке различных типов грузов</li>
          </ul>
        </div>
      </section>

      {/* Секция "Наши преимущества" */}
      <section className="nebortovye-advantages">
        <div className="container">
          <h2>Наши преимущества</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Скорость</h3>
              <p>Быстрая загрузка и разгрузка благодаря специальному оборудованию.</p>
            </div>
            <div className="advantage-item">
              <h3>Экономичность</h3>
              <p>Снижение затрат за счёт оптимизации логистики и эффективного использования транспорта.</p>
            </div>
            <div className="advantage-item">
              <h3>Гибкость</h3>
              <p>Возможность перевозить различные типы грузов без ограничений по конструкции кузова.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Секция "Схема работы" */}
      <section className="nebortovye-scheme">
        <div className="container">
          <h2>Схема работы</h2>
          <div className="scheme-steps">
            <div className="scheme-step">
              <div className="scheme-icon step-icon-1"></div>
              <p>Принимаем заявку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-2"></div>
              <p>Планируем погрузку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-3"></div>
              <p>Организуем перевозку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-4"></div>
              <p>Разгружаем груз</p>
            </div>
          </div>
        </div>
      </section>

      {/* Секция "Анимированные цифры" */}
      <section className="nebortovye-numbers">
        <div className="container">
          <div className="numbers-grid">
            <div className="number-item">
              <h2>
                <CountUp 
                  end={300} 
                  duration={2} 
                  suffix="+" 
                  enableScrollSpy 
                  scrollSpyOnce 
                />
              </h2>
              <p>грузов перевозится ежегодно</p>
            </div>
            <div className="number-item">
              <h2>
                <CountUp 
                  end={1200} 
                  duration={2} 
                  enableScrollSpy 
                  scrollSpyOnce 
                />
              </h2>
              <p>отправлений ежемесячно</p>
            </div>
            <div className="number-item">
              <h2>
                <CountUp 
                  end={850} 
                  duration={2} 
                  enableScrollSpy 
                  scrollSpyOnce 
                />
              </h2>
              <p>тыс. тонн груза</p>
            </div>
            <div className="number-item">
              <h2>
                <CountUp 
                  end={10} 
                  duration={2} 
                  enableScrollSpy 
                  scrollSpyOnce 
                />
              </h2>
              <p>лет опыта</p>
            </div>
          </div>
        </div>
      </section>

      {/* Форма заявки */}
      <section className="nebortovye-request">
        <div className="container">
          <h2>Оставьте заявку на небортовые перевозки</h2>
          <p>Наш менеджер свяжется с вами для уточнения всех деталей</p>
          <form className="request-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Ваше имя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Ваш телефон"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <button type="submit">Отправить заявку</button>
          </form>
          {responseMsg && <p className="response-message">{responseMsg}</p>}
          <p className="disclaimer">
            Нажимая на кнопку, вы соглашаетесь на обработку персональных данных
          </p>
        </div>
      </section>
    </div>
  );
};

export default Nebortovye;
